import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, ModalController, ViewDidEnter } from '@ionic/angular';
import * as dayjs from 'dayjs';
import {
  MenuCategory,
  MenuItem,
  MenuSection,
} from 'src/app/models/rich-data.model';
import { SalesHeader, SalesLine } from 'src/app/models/sales-header.model';
import { CaptionPipe } from 'src/app/pipes/caption.pipe';
import { AnalyticsService } from 'src/app/services/analytics.service';
import { AuthService } from 'src/app/services/auth.service';
import { CartService } from 'src/app/services/cart.service';
import { DataService } from 'src/app/services/data.service';
import { ModalMakerService } from 'src/app/services/modal-maker.service';
import { RequestService } from 'src/app/services/request.service';
import { ExternalRequestModel } from '../../../models/external-request.model';
import { AdditionalFormField } from 'src/app/models/request-header.model';
import { CartModel } from 'src/app/models/cart.model';
import { GetTranslationService } from 'src/app/services/get-translation.service';
import { ToastMachineService } from '../../../services/toast-machine.service';

@Component({
  selector: 'app-cart',
  templateUrl: './cart.component.html',
  styleUrls: ['./cart.component.scss'],
})
export class CartComponent implements ViewDidEnter, OnInit {
  @Input() menuItem: MenuItem;
  @Input() menuSection: MenuSection;
  @Input() menuCategory: MenuCategory;

  orderTime: string = dayjs(new Date()).format('HH:mm');
  capacityName: string;
  phoneNumber: string;
  name: string;
  basketResponse: any;
  changeAmountItems = [];
  animateClasses: string[] = [];
  isValid = true;
  isSubmitting = false; // Add this line to track submission state

  constructor(
    private mdlctrl: ModalController,
    public authServ: AuthService,
    public dataServ: DataService,
    public cartServ: CartService,
    private router: Router,
    private analytics: AnalyticsService,
    private caption: CaptionPipe,
    private requestServ: RequestService,
    public alertController: AlertController,
    private translator: GetTranslationService,
    private toaster: ToastMachineService
  ) {}

  ngOnInit() {
    // authServ.profile ve cartServ.cart hazır mı kontrol et
    if (this.authServ.profile && this.cartServ.cart.length > 0) {
      this.checkBasket();
    } else {
      if (!this.dataServ.menuItem.profile_is_not_required) {
        this.authServ.getMe().then(() => {
          this.checkBasket();
        });
      }
    }
    
    console.log(this.dataServ.menuItem);
    console.log(this.cartServ.cart);
    
    
    // Eğer veriler daha sonra geliyorsa, burada subscribe edebilirsin
    // örn: this.authServ.profileChanged.subscribe(() => this.checkBasket());
    // veya cartServ.cart değişimini dinleyebilirsin
  }

  async checkBasket() {
    const basket = {
      profile_id: this.authServ.profile?.id,
      hotel_id: this.authServ.profile?.hotel_id,
      menu_item_id: this.cartServ.cart[0]?.item.id,
      lines: [],
    };

    this.cartServ.cart.forEach((cart) => {
      let line = {
        menu_item_catalog_price_id: cart.size.id,
        type: 'Item',
        quantity: cart.size.quantity,
      };
      basket.lines.push(line);
      this.animateClasses.push('');
    });

    try {
      const response = await this.requestServ.getBasket(basket);
      this.basketResponse = response;
      let priceChanged = false;
      this.changeAmountItems = [];
      this.cartServ.cart.forEach((cart, index) => {
        const newAmount =
          response.lines?.find(
            (line) => line.menu_item_catalog_price_id == cart.size.id
          )?.amount ?? 0;
        if (cart.amount !== undefined && cart.amount !== newAmount) {
          priceChanged = true;
          this.changeAmountItems.push(cart);
          this.animateClasses[index] = 'shake';
          setTimeout(() => {
            this.animateClasses[index] = '';
          }, 500);
        } else {
          this.animateClasses[index] = '';
        }
        cart.amount = newAmount;
      });

      this.cartServ.totalAmount = response.amount;

      if (priceChanged) {
        const MSG = await this.translator.getTranslate(
          "We've made some updates to the prices in your product list."
        );
        this.toaster.toastMachine(MSG, 'warning', 5000);
      }
    } catch (error) {
      console.error('Error in checkBasket:', error);
    }
  }
  ionViewDidEnter() {
    document.querySelectorAll('ion-button').forEach((btn) => {
      btn.addEventListener('click', (event: Event) => {
        this.analytics.eventEmitter(
          `${this.caption.transform(
            this.dataServ.menuItem.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_click`,
          'button',
          'click',
          `${this.caption.transform(
            this.dataServ.menuItem.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_click`,
          this.dataServ.menuItem.id
        );
      });
    });

    if (sessionStorage.getItem('tableNo')) {
      this.capacityName = sessionStorage.getItem('tableNo');
    }
  }

  async close() {
    await this.mdlctrl.dismiss();
  }

  async writeNote(item: CartModel) {
    const NOTE = await this.translator.getTranslate(
      'Enter your special requests.'
    );
    const CANCEL = await this.translator.getTranslate('Cancel');
    const SAVE = await this.translator.getTranslate('Save');

    const alert = await this.alertController.create({
      header:
        this.caption.transform(item.product.name) +
        ' (' +
        this.caption.transform(item.size.size) +
        ')',
      inputs: [
        {
          name: 'note',
          type: 'textarea',
          placeholder: NOTE,
          value: item.note ? item.note : '',
        },
      ],
      buttons: [
        {
          text: CANCEL,
          role: 'cancel',
          cssClass: 'secondary',
          handler: () => {},
        },
        {
          text: SAVE,
          handler: (data) => {
            item.note = data.note;
          },
        },
      ],
    });

    await alert.present();
  }

  async checkCurrentAmount() {
    try {
      if (!this.basketResponse) {
        this.basketResponse = {
          profile_id: this.authServ.profile?.id,
          hotel_id: this.dataServ.rData?.id,
          menu_item_id: this.cartServ.cart[0]?.item.id,
          lines: [],
        };
        this.cartServ.cart.forEach((cart) => {
          let line = {
            menu_item_catalog_price_id: cart.size.id,
            type: 'Item',
            quantity: cart.size.quantity,
          };
          this.basketResponse.lines.push(line);
          this.animateClasses.push('');
        });
      }
      const response = await this.requestServ.getBasket(this.basketResponse);
      this.basketResponse = response;
      
      this.changeAmountItems = [];
      this.cartServ.cart.forEach((cart) => {
        let newItemAmount =
          response.lines?.find(
            (line) => line.menu_item_catalog_price_id == cart.size.id
          ).amount ?? 0;
        if (cart.amount != newItemAmount) {
          cart.amount = newItemAmount;
          this.changeAmountItems.push(cart);
        }
      });
      this.cartServ.totalAmount = response.amount ?? 0;
      if (this.changeAmountItems.length > 0) {
        return false;
      } else {
        return true;
      }
    } catch (error) {
      console.error('Error in checkCurrentAmount:', error);
      throw error;
    }
  }
  checkFormFieldsValidation() {
    if (this.dataServ.menuItem.form_fields) {
      for (
        let index = 0;
        index < this.dataServ.menuItem.form_fields.length;
        index++
      ) {
        const field = this.dataServ.menuItem.form_fields[index];

        if (field.is_required) {
          if (
            field.value === undefined ||
            field.value === null ||
            field.value === ''
          ) {
            this.isValid = false;

            const el = document.getElementById('form-' + index);
            if (el) {
              el.scrollIntoView({ behavior: 'smooth' });
              el.classList.add('error');
            }

            break; // Döngüden çık
          } else {
            const el = document.getElementById('form-' + index);
            if (el) {
              el.classList.remove('error');
            }
            this.isValid = true;
          }
        }
      }
    }
  }
  async send(note: string) {
    // Prevent multiple submissions
    if (this.isSubmitting) {
      return;
    }

    // Set loading state
    this.isSubmitting = true;

    this.checkFormFieldsValidation();

    if (!this.isValid) {
      const MSG = await this.translator.getTranslate(
        'Please fill in the required fields'
      );
      this.toaster.toastMachine(MSG, 'danger', 3000);
      this.isSubmitting = false; // Reset loading state
      return;
    }

    const result = await this.checkCurrentAmount();
    if (result) {
      try {
        const ORDERTIME = dayjs(new Date())
          .set('hour', +this.orderTime.split(':')[0])
          .set('minute', +this.orderTime.split(':')[1])
          .set('second', 0)
          .set('millisecond', 0)
          .toISOString();
        if (this.menuItem.profile_is_not_required && !this.authServ.isLogged) {
          const externalRequest = new ExternalRequestModel();

          if (
            this.menuItem.form_fields &&
            this.menuItem.form_fields.length > 0
          ) {
            externalRequest.additional_form_fields = [];
            for (const form of this.menuItem.form_fields) {
              const FIELD = new AdditionalFormField(form);
              externalRequest.additional_form_fields.push(FIELD);
            }
          }

          externalRequest.hotel_id = this.menuItem.hotel_id;
          externalRequest.profile_name = this.name;
          externalRequest.phone_no = this.phoneNumber;
          externalRequest.capacity_name = this.capacityName;
          externalRequest.menu_item_id = this.menuItem.id;
          externalRequest.order_date = new Date(ORDERTIME);
          externalRequest.note = note;
          externalRequest.amount = 0;
          externalRequest.locale = localStorage.getItem('userLang');

          await this.cartServ.externalRequest(externalRequest);
        }

        if (this.dataServ.menuItem.mobile_payment && this.authServ.isLogged) {
          const PAYMENTTYPE = await this.requestServ.getPaymentProvider();

          //PAYMENT TİPİ GPE PAY İSE
          if (
            PAYMENTTYPE.name === 'GPEPay' ||
            PAYMENTTYPE.name === 'BULUTTahsilat'
          ) {
            const REQUEST = await this.cartServ.request(
              ORDERTIME,
              note,
              this.menuSection,
              this.menuItem,
              sessionStorage.getItem('tableNo'),
              'paymentProcessing'
            );

            REQUEST.payment_type = 'Online';
            REQUEST.capacity_name = this.capacityName;

            // SALES HEADER
            const SALESHEADER = new SalesHeader(
              REQUEST,
              this.authServ.profile,
              this.dataServ.rData
            );
            SALESHEADER.currency =
              REQUEST.requestlines[0].currency_code == 'TL'
                ? 'TRY'
                : REQUEST.requestlines[0].currency_code == '$'
                ? 'USD'
                : REQUEST.requestlines[0].currency_code == '€'
                ? 'EUR'
                : REQUEST.requestlines[0].currency_code == '£'
                ? 'GBP'
                : 'TRY';
            SALESHEADER.payment_method_code = 'CreditCard';
            SALESHEADER.invoice_discount_calculation = 'None';

            for (const [INDEX, ITEM] of REQUEST.requestlines.entries()) {
              // const CARTITEM = this.carcart.find(x => x.size.menu_item_catalog_id === ITEM.request_type_id);
              const CARTITEM = this.cartServ.cart.find(
                (x) => x.size.menu_item_catalog_id === ITEM.request_type_id
              );

              let discount: {
                type: 'None' | '%' | 'LineAmount';
                discountAmount: number;
                basePrice: number;
                invoiceDiscount: number;
              } = null;

              if (CARTITEM) {
                discount = {
                  type: CARTITEM.discountType || 'None',
                  discountAmount: CARTITEM.discountAmount,
                  basePrice: CARTITEM.basePrice * CARTITEM.size.quantity,
                  invoiceDiscount: 0,
                };
              } else {
                discount = {
                  type: 'None',
                  discountAmount: 0,
                  basePrice: ITEM.amount,
                  invoiceDiscount: 0,
                };
              }
              const SALESLINE = new SalesLine(
                REQUEST,
                ITEM,
                this.authServ.profile,
                INDEX + 1,
                discount,
                0
              );
              SALESLINE.type = 'Item';
              SALESHEADER.sales_lines.push(SALESLINE);
            }

            SALESHEADER.sales_lines.forEach((line) => {
              SALESHEADER.invoice_amount += line.line_amount;
            });

            SALESHEADER.redirect_success_url =
              window.location.origin + '/payment-successfull';

            SALESHEADER.redirect_un_success_url =
              window.location.origin + '/payment-failed';

            const IFRAMEURLBASE64 = await this.requestServ.sendSale(
              SALESHEADER
            );

            const IFRAMEURL = atob(IFRAMEURLBASE64.pay_url);

            this.analytics.eventEmitter(
              `${this.caption.transform(
                this.dataServ.menuItem.name,
                this.dataServ.rData.hotel_language || 'tr'
              )}_buy`,
              'button',
              'click',
              `${this.caption.transform(
                this.dataServ.menuItem.name,
                this.dataServ.rData.hotel_language || 'tr'
              )}_buy`,
              this.dataServ.menuItem.id
            );

            window.location.href = IFRAMEURL;

            //target blank
            // window.open(IFRAMEURL, '_blank');

            // this.modalServ.showPaymentModal(IFRAMEURL);
          }
        } else if (this.authServ.isLogged) {
          await this.cartServ.request(
            ORDERTIME,
            note,
            this.menuSection,
            this.menuItem,
            sessionStorage.getItem('tableNo')
              ? sessionStorage.getItem('tableNo')
              : this.capacityName
          );
        }
        const URL = this.router.url.split('/');

        URL.shift();

        this.analytics.eventEmitter(
          `${this.caption.transform(
            this.dataServ.menuItem.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_buy`,
          'button',
          'click',
          `${this.caption.transform(
            this.dataServ.menuItem.name,
            this.dataServ.rData.hotel_language || 'tr'
          )}_buy`,
          this.dataServ.menuItem.id
        );

        const routeUrl = '/' + URL[0];
        this.router.navigateByUrl(routeUrl);
        this.close();
      } catch (error) {
        console.error('Error in send:', error);
        this.isSubmitting = false; // Reset loading state on error
      }
    } else {
      const MSG = await this.translator.getTranslate(
        "We've made some updates to the prices in your product list."
      );
      this.toaster.toastMachine(MSG, 'warning', 5000);
      this.cartServ.cart.forEach((item, index) => {
        let isNewItem = this.changeAmountItems.find(
          (line) => line.size.id == item.size.id
        );
        if (isNewItem != undefined) {
          this.animateClasses[index] = 'shake';
          setTimeout(() => {
            this.animateClasses[index] = '';
          }, 500);
        } else {
          this.animateClasses[index] = '';
        }
      });
      this.isSubmitting = false; // Reset loading state
    }
  }
}
